import React, { ForwardedRef, forwardRef } from 'react';
import { Icon } from 'react-feather';
import PropTypes from 'prop-types';

const AddedDocument: Icon = forwardRef(
  (
    { color = 'currentColor', size = 16, ...rest },
    ref: ForwardedRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 14 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          d="M12.2999 3.69069L9.97592 1.36668C9.54364 0.93207 9.02946 0.587499 8.46313 0.352912C7.8968 0.118325 7.28958 -0.00162038 6.67659 1.65308e-05H3.66659C2.78286 0.0010751 1.93562 0.352605 1.31073 0.977497C0.68584 1.60239 0.334311 2.44962 0.333252 3.33335V12.6667C0.334311 13.5504 0.68584 14.3977 1.31073 15.0225C1.93562 15.6474 2.78286 15.999 3.66659 16H10.3333C11.217 15.999 12.0642 15.6474 12.6891 15.0225C13.314 14.3977 13.6655 13.5504 13.6666 12.6667V6.99002C13.6682 6.37703 13.5483 5.76981 13.3137 5.20348C13.0791 4.63715 12.7345 4.12297 12.2999 3.69069ZM11.3573 4.63335C11.5606 4.84296 11.7357 5.07829 11.8779 5.33335H8.99992C8.82311 5.33335 8.65354 5.26312 8.52852 5.13809C8.40349 5.01307 8.33325 4.8435 8.33325 4.66669V1.78868C8.58832 1.93094 8.82365 2.10598 9.03325 2.30935L11.3573 4.63335ZM12.3333 12.6667C12.3333 13.1971 12.1225 13.7058 11.7475 14.0809C11.3724 14.456 10.8637 14.6667 10.3333 14.6667H3.66659C3.13615 14.6667 2.62745 14.456 2.25237 14.0809C1.8773 13.7058 1.66659 13.1971 1.66659 12.6667V3.33335C1.66659 2.80292 1.8773 2.29421 2.25237 1.91914C2.62745 1.54406 3.13615 1.33335 3.66659 1.33335H6.67659C6.78659 1.33335 6.89192 1.35468 6.99992 1.36468V4.66669C6.99992 5.19712 7.21063 5.70583 7.58571 6.0809C7.96078 6.45598 8.46949 6.66669 8.99992 6.66669H12.3019C12.3119 6.77469 12.3333 6.88002 12.3333 6.99002V12.6667ZM10.1493 8.87402C10.271 9.00208 10.3369 9.17322 10.3325 9.34985C10.3282 9.52648 10.2538 9.69415 10.1259 9.81602L7.73325 12.092C7.35715 12.4622 6.84997 12.6688 6.32225 12.6666C5.79453 12.6645 5.28904 12.4539 4.91592 12.0807L3.88925 11.1647C3.75718 11.0469 3.67729 10.8815 3.66716 10.7049C3.66214 10.6174 3.67441 10.5298 3.70325 10.4471C3.73209 10.3643 3.77695 10.2881 3.83525 10.2227C3.89356 10.1573 3.96418 10.104 4.04307 10.0659C4.12197 10.0278 4.2076 10.0056 4.29507 10.0006C4.47173 9.99047 4.64518 10.0509 4.77725 10.1687L5.83392 11.1114C5.89441 11.1793 5.96816 11.2341 6.05064 11.2725C6.13311 11.3108 6.22257 11.3319 6.31349 11.3344C6.40442 11.3369 6.49489 11.3208 6.57935 11.287C6.66381 11.2532 6.74046 11.2025 6.80459 11.138L9.20459 8.85069C9.26805 8.79001 9.34287 8.74247 9.42476 8.71078C9.50665 8.6791 9.59399 8.66391 9.68177 8.66608C9.76955 8.66825 9.85603 8.68773 9.93626 8.72342C10.0165 8.7591 10.0889 8.81029 10.1493 8.87402Z"
          fill={color}
        />
      </svg>
    );
  }
);

AddedDocument.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

AddedDocument.displayName = 'AddedDocument';

export default AddedDocument;
